import { getFahrzeugFarbe, berechneFahrzeugNummerInTyp } from '../einteilung/constants';

// Hauptdienste bilden die Teile eines Ganzen; zusätzliche Springer zählen separat.
export function buildVehicleDistribution(statistik, fahrzeuge = []) {
  const total = statistik?.anzahl_gesamt || 0;
  const parts = (statistik?.fahrzeuge || [])
    .filter(vehicle => vehicle.anzahl_haupt > 0)
    .flatMap(vehicle => {
      const definition = fahrzeuge.find(item => item.id === vehicle.fahrzeug_id) || {};
      const name = vehicle.kurzname || vehicle.funkrufname;
      const typ = definition.typ || name?.match(/^[A-Za-z]+/)?.[0] || '';
      const color = getFahrzeugFarbe({ ...definition, typ });
      const number = berechneFahrzeugNummerInTyp(fahrzeuge, definition);
      const functions = (vehicle.funktionen || [])
        .map(fn => {
          const code = (fn.kuerzel || '').replace(/^(RTW|LHF|DLK|NEF|ELW)-/i, '');
          const label = typ === 'RTW' ? `${code}${number}` : `${code} ${typ}${number}`.trim();
          return {
            id: `${vehicle.fahrzeug_id}:${fn.kuerzel}`,
            name: `${label} · ${name}`, label, color,
            value: (fn.haupt_tag || 0) + (fn.haupt_nacht || 0),
          };
        })
        .filter(fn => fn.value > 0);
      const remainder = vehicle.anzahl_haupt - functions.reduce((sum, fn) => sum + fn.value, 0);
      if (remainder > 0) functions.push({ id: vehicle.fahrzeug_id, name, label: name, color, value: remainder });
      return functions;
    });
  const remaining = total - parts.reduce((sum, part) => sum + part.value, 0);
  if (remaining > 0) parts.push({ id: 'unassigned', name: 'Nicht mehr zugeordnet', label: 'Ohne Zuordnung', color: '#64748b', value: remaining });
  return parts.map(part => ({ ...part, percent: total ? part.value / total * 100 : 0 }));
}
